import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  LoggedInUserKeys,
  LoggedInUserService,
} from '../service/logged-in-user.service';
import { AppUsersDto } from '../model/app-users-dto';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private loggedInUserService: LoggedInUserService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const loggedInUserStringValue = this.loggedInUserService.getLoggedInUser(
      LoggedInUserKeys.LOGGED_IN_USER
    );

    // URLs to exclude from adding the default Authorization header
    const excludedUrls = [
      'https://geolocation-db.com/json/',
      'https://s3.ap-south-1.amazonaws.com',
      'https://f360-uat.s3.ap-south-1.amazonaws.com',
      'https://exam-code-submissions.s3.ap-south-1.amazonaws.com',
      'https://exam-code-submission-prod.s3.ap-south-1.amazonaws.com',
      '/gpu/videoproctoring',
      '/proctorqueue/'

    ];

    const isPresignedS3Url =
      /^https:\/\/(?:[^/?#]*\.)?s3(?:[.-][a-z0-9-]+)*\.amazonaws\.com(?::\d+)?(?:[/?#]|$)/i.test(
        request.url
      );

    // Check if the current request URL should bypass the logged-in user token
    const shouldExclude =
      isPresignedS3Url ||
      excludedUrls.some((url) =>
        request.url.toLowerCase().includes(url.toLowerCase())
      );

    const ssoLogin = sessionStorage.getItem('SSO_LOGIN'); // 'true' or 'false'

    if (!shouldExclude && loggedInUserStringValue) {
      const loggedInUser: AppUsersDto = loggedInUserStringValue;
      const headers: { [key: string]: string } = {};

      // Only sessions from before the cookie switch still hold the token; a cookie
      // session is sent by the browser and must not be overridden by a header.
      if (loggedInUser && loggedInUser.authToken) {
        headers['Authorization'] = 'Bearer ' + loggedInUser.authToken;
      }

      // Add extra header if SSO login is true
      if (ssoLogin === 'true' && this.loggedInUserService.isLoggedIn()) {
        headers['X-SSO-SUB'] = String(ssoLogin === 'true');
      }

      if (Object.keys(headers).length) {
        request = request.clone({
          setHeaders: headers,
        });
      }
    }

    // Pass the request along the chain
    return next.handle(request);
  }
}
